<div class="testimonial-container">
    <owl-carousel-o [options]="owlTestimonial">
    <!-- <p-carousel [value]="testimonials" [numVisible]="2" [numScroll]="1" [circular]="false" [showIndicators]="false" [autoplayInterval]="8000"> -->
        <ng-container>
            <ng-template carouselSlide *ngFor="let testimonial of testimonials; let oi = index">
            <div class="testimonial-card">
                <div>
                <p class="quote">"{{ testimonial.feedback }}</p>
                <p class="quote sub-quote">{{ testimonial.subfeedback }}"</p>
                </div>
                <div class="author">
                    <img [src]="testimonial.image" alt="Customer Image">
                    <div class="author-info">
                        <h3>{{ testimonial.name }}</h3>
                        <p>{{ testimonial.designation }}</p>
                        <p-rating [(ngModel)]="testimonial.value" [cancel]="false" />
                    </div>
                </div>
            </div>
        </ng-template>
  </ng-container>
    </owl-carousel-o>
    
</div>
